import { Component, EventEmitter, inject, Input, LOCALE_ID, OnInit, Optional, Output } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { PrimeTemplate } from 'primeng/api'
import { MultiSelect } from 'primeng/multiselect'
import { ASSET_CATEGORIES } from '@app/constants/constants'
import { StaticDropDown } from '@app/components/generic/generic'
import { DetailMode } from '@app/components/generic/generic.constants'

@Component({
  selector: 'app-asset-categories-field',
  templateUrl: 'asset-categories-field.component.html',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    MultiSelect,
    FormsModule,
    PrimeTemplate,
  ],
})
export class AssetCategoriesFieldComponent implements OnInit {
  public readonly locale = inject(LOCALE_ID)

  @Input() assetCategories?: string[]
  @Input() required: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() assetCategoriesChange = new EventEmitter<string[]>()

  public assetCategoryOptions: StaticDropDown[] = []
  public filterLabelField = 'label_en'
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    if (this.locale === 'fr') {
      this.filterLabelField = 'label_fr'
    }

    this.assetCategoryOptions = ASSET_CATEGORIES
  }
}
